import React, { useState } from 'react'
import { Box } from '@mui/system'
import './Filter.css'
import{
  Button
} from "@mui/material";
import HeightIcon from '@mui/icons-material/Height';
const Filter = ({handleGenre,handleAge,handleSort,filterGenre,filterAge}) => {



    return (
      <Box>      
      <Box className="filter1" bgcolor="primary.dark">
      <Button varient="contained" sx={{ px: 2, py: 1, m: 2, color: 'primary.main', backgroundColor:filterGenre==='All'?'white':'black', borderRadius: 10 }} onClick={()=>{handleGenre("All")}} >
                All Genre
          </Button>
            <Button varient="contained" sx={{ px: 2, py: 1, m: 2, color: 'primary.main', backgroundColor: filterGenre==='Education'?'white':'black', borderRadius: 10 }} onClick={()=>{handleGenre("Education")}}>
                Education
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterGenre==='Sports'?'white':'black',borderRadius:10}} onClick={()=>{handleGenre("Sports")}}>
                Sports
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterGenre==='Comedy'?'white':'black',borderRadius:10}} onClick={()=>{handleGenre("Comedy")}}>
                Comedy
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterGenre==='Lifestyle'?'white':'black',borderRadius:10}} onClick={()=>{handleGenre("Lifestyle")}}>
                Lifestyle
          </Button>
                      <Button startIcon={<HeightIcon/> } varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: 'white',borderRadius:10}} onClick={()=>{handleSort()}}>
                Sort BY Date
          </Button>
      </Box>
            <Box className="filter2" bgcolor="primary.dark">
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterAge==='Any'?'white':'black',borderRadius:10}} onClick={()=>{handleAge("Any")}}>
                Any Age Group
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterAge==='7+'?'white':'black',borderRadius:10}} onClick={()=>{handleAge("7+")}}>
                7+
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterAge==='12+'?'white':'black',borderRadius:10}} onClick={()=>{handleAge("12+")}}>
                12+
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterAge==='16+'?'white':'black',borderRadius:10}} onClick={()=>{handleAge("16+")}}>
                16+
          </Button>
          <Button varient="contained" sx={{px:2,py:1,m:2,color: 'primary.main', backgroundColor: filterAge==='18+'?'white':'black',borderRadius:10}} onClick={()=>{handleAge("18+")}}>
                18+
          </Button>
    </Box>
      </Box>

  )
}

export default Filter